import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
const MySwal = withReactContent(Swal2);
Quill.register("modules/imageResize", ImageResize);

const AdminPanelMaterialsConsultant = (props) => {
  const [templates, setTemplates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState("");
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [template, setTemplate] = useState("");
  const [templateName, setTemplateName] = useState("");

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      ["link", "image"],
    ],
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
    clipboard: {
      matchVisual: false,
    },
  };

  const handleTemplateChange = (e) => {
    setTemplate(e.target.value);
    if (e.target.value === "new") {
      var content = "";
      var subject = "";
      var department = "";
    } else {
      var content = templates.filter((el) => +el.id === +e.target.value)[0]
        .content;
      var subject = templates.filter((el) => +el.id === +e.target.value)[0]
        .name;
      var department = templates.filter((el) => +el.id === +e.target.value)[0]
        .department;
    }

    setValue(content);
    setSubject(subject);
    setDepartment(department);
  };

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialsConsultant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTemplates(data);
        fetchDepartments();
      })
      .catch((error) => {});
  };

  const fetchDepartments = async () => {
    var body = {};

    await fetch(
      "https://apidevkppp.ftpeople.pl/getMaterialsConsultantDepartments",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const sendTemplate = (e) => {
    if (template) {
      if (template === "new") {
        addTemplate();
      } else {
        updateTemplate();
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wybierz",
        text: "materiał",
      }).then(async (result) => {});
    }
  };

  const updateTemplate = async () => {
    var body = {
      id: template,
      name: subject,
      content: value,
      department: department,
    };

    await fetch("https://apidevkppp.ftpeople.pl/updateMaterialConsultant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "materiał",
        }).then((result) => {
          getData();
        });
      });
  };

  const addTemplate = async () => {
    var body = {
      name: templateName,
      content: value,
      department: department,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertMaterialConsultant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "materiał",
        }).then((result) => {
          getData();
        });
      });
  };

  const deleteTemplate = async () => {
    var body = {
      id: template,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteMaterialConsultant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "materiał",
        }).then((result) => {
          getData();
        });
      });
  };

  return (
    <div className="mainContainerPayments">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div
            style={{ width: "100%" }}
            id="addPaymentIC"
            className="inputContainer"
          >
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Wybierz materiał <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={template}
                  onChange={handleTemplateChange}
                >
                  {!template ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {templates.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                  <option key={"0x"} value={"new"}>
                    {"Nowy szablon"}
                  </option>
                </select>
              </div>
            </div>
            {template === "new" ? (
              <>
                <div style={{ marginTop: "3vh" }}>
                  <label>Nazwa szablonu</label>
                  <input
                    type="text"
                    id="signature"
                    name="signature"
                    value={templateName}
                    onChange={(e) => {
                      setTemplateName(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : (
              ""
            )}

            {template !== "new" ? (
              <>
                <div style={{ marginTop: "3vh" }}>
                  <label>Nazwa szablonu</label>
                  <input
                    type="text"
                    id="signature"
                    name="signature"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : (
              ""
            )}

            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Dział <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={department}
                  onChange={(e) => {
                    setDepartment(e.target.value);
                  }}
                >
                  {!department ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {departments.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>

            <label style={{ marginTop: "2vh" }}>Materiał</label>
            <div
              style={{
                marginTop: "1vh",
                border: "1px solid black",
                borderRadius: "15px",
              }}
            >
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules}
              />
            </div>

            <div style={{ display: "flex", gap: "20px" }} className="saveBoxAP">
              {template.length > 0 ? (
                <>
                  <button className="paymentMenuButton" onClick={sendTemplate}>
                    Zapisz
                  </button>
                </>
              ) : (
                ""
              )}

              {template.length > 0 && template !== "new" ? (
                <>
                  <button
                    className="paymentMenuButton"
                    onClick={deleteTemplate}
                  >
                    Usuń
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminPanelMaterialsConsultant;
